import { FC } from "react"

export const AirkitIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg width="79" height="35" viewBox="0 0 79 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.666504" width="77.6667" height="35" rx="4" fill="#F7F7F7" />
      <g clipPath="url(#clip0_176_1581)">
        <path
          d="M22.2527 11.8594H21.4393C20.5962 11.8594 19.7975 12.2585 19.2946 12.9237L11.5 23.2124H14.3102C14.7983 23.2124 15.2568 22.9758 15.5526 22.5915L19.413 17.4915V23.2124H22.2675V11.8594H22.2527Z"
          fill="#ACACAC"
        />
        <path
          d="M30.1343 11.8303H27.3389C26.8508 11.8303 26.3923 12.0521 26.0965 12.4512L22.251 17.5216L26.0817 22.592C26.3775 22.9911 26.836 23.2129 27.3241 23.2129H30.1196L25.8155 17.5216L30.1343 11.8303Z"
          fill="#ACACAC"
        />
        <path
          d="M22.2527 11.8594H21.4393C20.5962 11.8594 19.7975 12.2585 19.2946 12.9237L11.5 23.2124H14.3102C14.7983 23.2124 15.2568 22.9758 15.5526 22.5915L19.413 17.4915C19.413 17.4915 22.2675 12.8498 22.2675 16.915C22.2675 14.9637 22.2527 11.8594 22.2527 11.8594Z"
          fill="#ACACAC"
        />
        <path
          d="M30.1343 11.8303H27.3389C26.8508 11.8303 26.3923 12.0521 26.0965 12.4512L22.251 17.5216L26.0817 22.592C26.0817 22.592 23.9667 19.9755 25.8155 17.5216C27.6643 15.0677 30.1343 11.8303 30.1343 11.8303Z"
          fill="#ACACAC"
        />
        <path
          d="M62.6602 15.541H63.5771V13.3828H65.1451V15.0532C65.1451 15.3193 65.3667 15.541 65.6183 15.541H66.816V16.8567H65.1451V19.8723C65.1451 20.7889 65.4258 21.0402 66.0765 21.0402C66.3427 21.0402 66.6531 20.981 66.8901 20.9219V22.208C66.5352 22.3115 66.0915 22.3558 65.692 22.3558C64.0207 22.3558 63.5771 21.3358 63.5771 19.961V16.8567H62.6602V15.541Z"
          fill="#ACACAC"
        />
        <path
          d="M40.9491 22.3558H39.3961V21.4837H39.3517C38.8784 22.0602 38.1537 22.4741 37.0296 22.4741C35.5062 22.4741 33.894 21.2176 33.894 18.9411C33.894 16.9602 35.2991 15.4524 37.1331 15.4524C38.272 15.4524 38.9523 15.9255 39.3517 16.4724H39.3813V15.5559H40.9195V22.3558H40.9491ZM37.4586 20.9811C38.4939 20.9811 39.4404 20.168 39.4404 19.0002C39.4404 17.7732 38.5678 16.9602 37.4733 16.9602C36.0978 16.9602 35.4322 17.9654 35.4322 18.9559C35.4322 19.9758 36.083 20.9811 37.4586 20.9811Z"
          fill="#ACACAC"
        />
        <path
          d="M50.5908 16.8566C50.3983 16.827 50.147 16.7827 49.7921 16.7827C49.0229 16.7975 48.0764 17.4922 48.0764 18.9114V22.3557H46.4937V15.5557H48.0467V16.5166H48.0913C48.4018 15.9401 49.0821 15.334 49.9843 15.334C50.2356 15.334 50.4132 15.3488 50.5759 15.3784V16.8566H50.5908Z"
          fill="#ACACAC"
        />
        <path d="M42.9458 15.5564H44.5284V22.3564H42.9458V15.5564Z" fill="#ACACAC" />
        <path
          d="M42.8276 13.4718C42.8276 13.2205 42.9164 13.0135 43.0939 12.8362C43.2713 12.6588 43.4784 12.5701 43.7299 12.5701C43.9813 12.5701 44.2031 12.6588 44.3806 12.8362C44.5581 13.0135 44.6469 13.2205 44.6469 13.4718C44.6469 13.7231 44.5581 13.9448 44.3806 14.1222C44.2031 14.2996 43.9961 14.3883 43.7446 14.3883C43.4932 14.3883 43.2713 14.2996 43.0939 14.1222C42.9164 13.9596 42.8276 13.7379 42.8276 13.4718Z"
          fill="#ACACAC"
        />
        <path d="M59.7388 15.6089H61.3218V22.4089H59.7388V15.6089Z" fill="#ACACAC" />
        <path
          d="M59.6211 13.5243C59.6211 13.273 59.7094 13.066 59.8873 12.8886C60.0648 12.7113 60.2718 12.6226 60.523 12.6226C60.7742 12.6226 60.9962 12.7113 61.1737 12.8886C61.3516 13.066 61.4403 13.273 61.4403 13.5243C61.4403 13.7756 61.3516 13.9973 61.1737 14.1747C60.9962 14.3521 60.7892 14.4408 60.538 14.4408C60.2868 14.4408 60.0648 14.3521 59.8873 14.1747C59.7094 14.0121 59.6211 13.7904 59.6211 13.5243Z"
          fill="#ACACAC"
        />
        <path d="M53.5054 22.3561H51.9229V12.5701H53.5054V22.3561Z" fill="#ACACAC" />
        <path
          d="M56.1235 22.0309L53.4907 18.3944L55.9752 15.8074C56.1235 15.6448 56.3302 15.5562 56.5522 15.5562H58.2681L55.5462 18.3944L58.416 22.3561H56.7592C56.5226 22.3561 56.271 22.2378 56.1235 22.0309Z"
          fill="#ACACAC"
        />
      </g>
      <defs>
        <clipPath id="clip0_176_1581">
          <rect width="56" height="11.831" fill="white" transform="translate(11.5 11.5845)" />
        </clipPath>
      </defs>
    </svg>
  )
}

